// ===============================
// features/appbar/components/UpperNav.jsx
// ===============================
import { Box, IconButton, InputBase, Badge, Avatar } from "@mui/material";
import { AnimatePresence } from "framer-motion";

import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import FeedbackLink from "../../../components/FeedbackLink";
import { useNavigateWithFeedback } from "../../../hooks/useNavigateWithFeedback";
import { Container, Logo, SearchBox, Dropdown } from "../style/appbar.styles";
import { useSearchSuggestions } from "../hooks/useSearchSuggestions";
import logo512 from "../../../assets/logo512.png";

export default function UpperNav({
  isDesktop,
  toggleDrawer,
  scrolled,
  cartCount,
}) {
  const iconSize = scrolled ? 24 : 28;
  const navigate = useNavigateWithFeedback();

  const {
    searchOpen,
    setSearchOpen,
    searchValue,
    setSearchValue,
    filteredSuggestions,
  } = useSearchSuggestions();

  return (
    <Container>
      <IconButton onClick={toggleDrawer}>
        <MenuIcon />
      </IconButton>

      <FeedbackLink to="/">
        <Logo
          src={logo512}
          scrolled={scrolled}
          open={searchOpen}
          isDesktop={isDesktop}
        />
      </FeedbackLink>

      <SearchBox open={searchOpen} scrolled={scrolled}>
        <IconButton size="small" onClick={() => setSearchOpen((p) => !p)}>
          <SearchIcon fontSize="small" />
        </IconButton>

        <AnimatePresence>
          {searchOpen && (
            <>
              <InputBase
                autoFocus
                placeholder="ابحث عن منتجات..."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                sx={{ ml: 1, flex: 1 }}
              />

              {searchValue && (
                <Dropdown>
                  {filteredSuggestions.length > 0 ? (
                    filteredSuggestions.map((item) => (
                      <Box
                        key={item}
                        sx={{
                          p: 1,
                          borderRadius: 1,
                          cursor: "pointer",
                          "&:hover": { bgcolor: "grey.100" },
                        }}
                      >
                        {item}
                      </Box>
                    ))
                  ) : (
                    <Box sx={{ p: 1, color: "text.secondary" }}>
                      لا توجد نتائج
                    </Box>
                  )}
                </Dropdown>
              )}
            </>
          )}
        </AnimatePresence>
      </SearchBox>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Avatar
          sx={{ width: iconSize, height: iconSize }}
          onClick={() => navigate("/login")}
        />

        <IconButton onClick={() => navigate("/cart")}>
          <Badge badgeContent={cartCount} color="primary">
            <ShoppingCartOutlinedIcon sx={{ fontSize: iconSize }} />
          </Badge>
        </IconButton>
      </Box>
    </Container>
  );
}
